import { render } from "./SkillsComp.vue?vue&type=template&id=92800362"
import script from "./SkillsComp.vue?vue&type=script&lang=js"
export * from "./SkillsComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__